import { ISignupStateTypes } from "models/ISignupState";
import { SIGNUP_FLOW_STEPS } from "features/Signup/data";

const initialState: any = {
  isTermsAndConditionsAccepted: false,
  isEmailOtpRecieved: false,
  isEmailOtpVerified: false,
  is_in_api_call: false,
  // form_step: SIGNUP_FLOW_STEPS?.PHONE_NUMBER_VERIFICATION,

  isMobileOtpRecieved: false,
  isMobileOtpVerified: false,
  is_terms_and_conditions_done: false,
  isProfessionalDetailsUpdated: false,
  is_documents_uploaded: false,

  isFRVerificationDone: false,
  fRErrorMsg: "",

  entities: [],
  teams: [],
  sub_teams: [],
  designations: [],
  chat_history: {},
  chat_list: [],
  terms_and_condtions: "",
  educations: [],
  languages: [],
  locations: {},
  skills: [],
  category_skill_ids: [],
  is_other_selected: false,
  other: "",
  // form_step: SIGNUP_FLOW_STEPS?.FR_REGISTERED,
  form_step: SIGNUP_FLOW_STEPS?.EMAIL_VERIFICATION,

  // signup_status: [
  //   {
  //     signup_step: "EMAIL_VERIFICATION",
  //     step_completed: true,
  //     created_at: "2025-08-01T12:14:24.388912+05:30",
  //     updated_at: "2025-08-01T12:14:24.388912+05:30",
  //   },
  //   {
  //     signup_step: "PHONE_NUMBER_VERIFICATION",
  //     step_completed: false,
  //     created_at: "2025-08-01T12:14:24.393121+05:30",
  //     updated_at: "2025-08-01T12:14:24.393121+05:30",
  //   },
  //   {
  //     signup_step: "EDUCATION_DETAILS_SUBMITTED",
  //     step_completed: false,
  //     created_at: "2025-08-01T12:14:24.396104+05:30",
  //     updated_at: "2025-08-01T12:14:24.396104+05:30",
  //   },
  //   {
  //     signup_step: "PROFESSIONAL_DETAILS_SUBMITTED",
  //     step_completed: false,
  //     created_at: "2025-08-01T12:14:24.398894+05:30",
  //     updated_at: "2025-08-01T12:14:24.398894+05:30",
  //   },
  //   {
  //     signup_step: "LOCATION_DETAILS_SUBMITTED",
  //     step_completed: false,
  //     created_at: "2025-08-01T12:14:24.401949+05:30",
  //     updated_at: "2025-08-01T12:14:24.401949+05:30",
  //   },
  //   {
  //     signup_step: "BANK_DETAILS_SUBMITTED",
  //     step_completed: false,
  //     created_at: "2025-08-01T12:14:24.404891+05:30",
  //     updated_at: "2025-08-01T12:14:24.404891+05:30",
  //   },
  //   {
  //     signup_step: "TERMS_ACCEPTED",
  //     step_completed: false,
  //     created_at: "2025-08-01T12:14:24.407977+05:30",
  //     updated_at: "2025-08-01T12:14:24.407977+05:30",
  //   },
  //   {
  //     signup_step: "FR_REGISTERED",
  //     step_completed: false,
  //     created_at: "2025-08-01T12:14:24.411279+05:30",
  //     updated_at: "2025-08-01T12:14:24.411279+05:30",
  //   },
  // ],
  // employee_details: {
  //   employee_id: "j@gmail.com",
  //   first_name: "Asdfa",
  //   last_name: "Asdf",
  //   phone_number: "",
  //   designation_id: 0,
  //   designation: "",
  //   team_id: 0,
  //   team: "",
  //   sub_team_id: 0,
  //   sub_team: "",
  //   aadhaar_front_prefic: "",
  //   aadhaar_back_prefix: "",
  //   pan_card_front_prefix: "",
  //   permanent_address: "",
  //   country: "",
  //   state: "",
  //   city: "",
  //   pin_code: "",
  //   current_address: "",
  //   current_country: "",
  //   current_state: "",
  //   current_city: "",
  //   current_pin_code: "",
  //   education_details_id: 0,
  //   qualification: "",
  //   passing_out_year: "",
  //   languages_known: null,
  // },
  // bank_details: [],

  // signup_status: [],
  // employee_details: {
  //   employee_id: "",
  //   first_name: "",
  //   last_name: " ",
  //   phone_number: "",
  //   designation_id: 0,
  //   designation: "",
  //   team_id: 0,
  //   team: "",
  //   sub_team_id: 0,
  //   sub_team: "",
  //   aadhaar_front_prefic: "",
  //   aadhaar_back_prefix: "",
  //   pan_card_front_prefix: "",
  //   permanent_address: "",
  //   country: "",
  //   state: "",
  //   city: "",
  //   pin_code: "",
  //   current_address: "",
  //   current_country: "",
  //   current_state: "",
  //   current_city: "",
  //   current_pin_code: "",
  //   education_details_id: 0,
  //   qualification: "",
  //   passing_out_year: "",
  //   languages_known: null,
  // },
  // bank_details: [],
  // is_internal_anchor: false,

  // TEsting data

  // form_step: SIGNUP_FLOW_STEPS?.EMAIL_VERIFICATION,
  // form_step: SIGNUP_FLOW_STEPS?.SKILLS_SUBMITTED,

  // form_step: SIGNUP_FLOW_STEPS?.BANK_DETAILS_SUBMITTED,

  // signup_status: [
  //   {
  //     signup_step: "EMAIL_VERIFICATION",
  //     step_completed: true,
  //     created_at: "2025-08-02T00:54:13.948137+05:30",
  //     updated_at: "2025-08-02T00:54:13.948137+05:30",
  //   },
  //   {
  //     signup_step: "PROFESSIONAL_DETAILS_SUBMITTED",
  //     step_completed: true,
  //     created_at: "2025-08-02T00:54:13.958913+05:30",
  //     updated_at: "2025-08-02T00:54:13.958913+05:30",
  //   },
  //   {
  //     signup_step: "PHONE_NUMBER_VERIFICATION",
  //     step_completed: true,
  //     created_at: "2025-08-02T00:54:13.952407+05:30",
  //     updated_at: "2025-08-02T00:54:34.118896+05:30",
  //   },
  //   {
  //     signup_step: "DOCUMENTS_UPLOADED",
  //     step_completed: true,
  //     created_at: "2025-08-02T00:54:13.961829+05:30",
  //     updated_at: "2025-08-02T00:56:00.149103+05:30",
  //   },
  //   {
  //     signup_step: "LOCATION_DETAILS_SUBMITTED",
  //     step_completed: true,
  //     created_at: "2025-08-02T00:54:13.965177+05:30",
  //     updated_at: "2025-08-02T00:58:38.269103+05:30",
  //   },
  //   {
  //     signup_step: "EDUCATION_DETAILS_SUBMITTED",
  //     step_completed: true,
  //     created_at: "2025-08-02T00:54:13.95562+05:30",
  //     updated_at: "2025-08-02T00:58:59.61797+05:30",
  //   },
  //   {
  //     signup_step: "BANK_DETAILS_SUBMITTED",
  //     step_completed: true,
  //     created_at: "2025-08-02T00:54:13.968605+05:30",
  //     updated_at: "2025-08-02T01:01:45.919888+05:30",
  //   },
  //   {
  //     signup_step: "FR_REGISTERED",
  //     step_completed: true,
  //     created_at: "2025-08-02T00:54:13.975138+05:30",
  //     updated_at: "2025-08-02T01:01:57.149406+05:30",
  //   },
  //   {
  //     signup_step: "TERMS_ACCEPTED",
  //     step_completed: true,
  //     created_at: "2025-08-02T00:54:13.971764+05:30",
  //     updated_at: "2025-08-02T01:02:04.214991+05:30",
  //   },
  // ],

  // employee_id: "dileep123@gmail.com",
  // first_name: "first name",
  // last_name: "last name",
  // phone_number: "3323232324",
  // designation_id: 0,
  // designation: "",
  // team_id: 0,
  // team: "",
  // sub_team_id: 0,
  // sub_team: "",

  // aadhaar_front_prefix:
  //   "documents/dileep123@gmail.com/aadhaar_front/5b2d/PHOTO-2025-05-06-12-24-24 2.jpg",
  // aadhaar_back_prefix:
  //   "documents/dileep123@gmail.com/aadhaar_back/c421/PHOTO-2025-05-06-12-24-24.jpg",
  // pan_card_front_prefix:
  //   "documents/dileep123@gmail.com/pan_card_front/c421/PHOTO-2025-05-06-12-24-24 copy.jpg",
  // permanent_address: "permanent",
  // country: "1",
  // state: "1",
  // city: "1",
  // pin_code: "12321234",
  // current_address: "current",
  // current_country: "1",
  // current_state: "1",
  // current_city: "1",
  // current_pin_code: "f34543",
  // education_details_id: 113,
  // qualification: "B.Ed",
  // passing_out_year: "2023",
  // languages_known: ["Dutch", "Dogri"],
  // entity_id: "2c376b86-ec69-43c6-801a-bc4160ab8617",

  // bank_details: [
  //   {
  //     name_on_account: "23245432",
  //     registered_phone_number: "987678912321",
  //     account_number: "12345432112",
  //     ifsc: "23454323444",
  //     bank_name: "bank 1",
  //     is_primary: true,
  //     bank_details_verified: false,
  //     cashfree_reference_id: "",
  //     beneficiary_id: "",
  //     country_code: "",
  //   },
  //   {
  //     name_on_account: "sdfaf",
  //     registered_phone_number: "3323232324",
  //     account_number: "123456789012",
  //     ifsc: "SNBK0001234",
  //     bank_name: "sadfa",
  //     is_primary: true,
  //     bank_details_verified: true,
  //     cashfree_reference_id: "",
  //     beneficiary_id: "",
  //     country_code: "",
  //   },
  // ],
  // is_internal_anchor: false,
};

const reducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    // Loadings
    case ISignupStateTypes.SIGNUP_UPLOAD_DOCUMENTS_REQUEST:
    case ISignupStateTypes.SEND_EMAIL_OTP_REQUEST:
    case ISignupStateTypes.ACCEPT_SIGNUP_TERMS_AND_CONDITIONS_REQUEST:
    case ISignupStateTypes.SUBMIT_BANK_DETAILS_REQUEST:
    case ISignupStateTypes.SUBMIT_EDUCATION_DETAILS_REQUEST:
    case ISignupStateTypes.SUBMIT_LOCATION_DETAILS_REQUEST:
      return {
        ...state,
        is_in_api_call: true,
        error: "",
        bankDetailsError: "",
      };

    // FAilure cases
    case ISignupStateTypes.SUBMIT_BANK_DETAILS_FAILURE:
    case ISignupStateTypes.SUBMIT_LOCATION_DETAILS_FAILURE:
      return {
        ...state,
        is_in_api_call: false,
        error: payload?.error || "",
        bankDetailsError: payload?.error || "",
      };

    case ISignupStateTypes.UPDATE_SIGNUP_FORM_DETAILS:
      return {
        ...state,
        ...payload,
      };

    case ISignupStateTypes.SEND_EMAIL_OTP_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        isEmailOtpRecieved: true,
      };

    case ISignupStateTypes.SEND_EMAIL_OTP_FAILURE:
      return {
        ...state,
        is_in_api_call: false,
        isEmailOtpRecieved: false,
      };

    case ISignupStateTypes.VERIFY_EMAIL_OTP_REQUEST:
      return {
        ...state,
        is_in_api_call: true,
        isEmailOtpVerified: false,
      };

    case ISignupStateTypes.VERIFY_EMAIL_OTP_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        isEmailOtpVerified: true,
      };

    case ISignupStateTypes.VERIFY_EMAIL_OTP_FAILURE:
      return {
        ...state,
        is_in_api_call: false,
        isEmailOtpVerified: false,
      };

    // mobile otp section

    case ISignupStateTypes.SEND_MOBILE_OTP_REQUEST:
      return {
        ...state,
        is_in_api_call: true,
      };

    case ISignupStateTypes.SEND_MOBILE_OTP_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        isMobileOtpRecieved: true,
      };

    case ISignupStateTypes.SEND_MOBILE_OTP_FAILURE:
      return {
        ...state,
        is_in_api_call: false,
        isMobileOtpRecieved: false,
      };

    case ISignupStateTypes.VERIFY_MOBILE_OTP_REQUEST:
      return {
        ...state,
        is_in_api_call: true,
        isEmailOtpVerified: false,
      };

    case ISignupStateTypes.VERIFY_MOBILE_OTP_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        isMobileOtpVerified: true,
      };

    case ISignupStateTypes.VERIFY_MOBILE_OTP_FAILURE:
      return {
        ...state,
        is_in_api_call: false,
        isMobileOtpVerified: false,
      };

    // mobile otp section

    // submitting employee details

    case ISignupStateTypes.UPDATE_PROFESSIONAL_DETAILS_REQUEST:
      return {
        ...state,
        is_in_api_call: true,
      };

    case ISignupStateTypes.UPDATE_PROFESSIONAL_DETAILS_FAILURE:
      return {
        ...state,
        is_in_api_call: false,
        isProfessionalDetailsUpdated: false,
      };

    case ISignupStateTypes.UPDATE_PROFESSIONAL_DETAILS_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        isProfessionalDetailsUpdated: true,
      };

    // submitting employee details

    // fetching lists
    case ISignupStateTypes.FETCH_SINGUP_TEAMS_SUCCESS:
      return {
        ...state,
        teams: payload || [],
      };

    case ISignupStateTypes.FETCH_SINGUP_SUB_TEAMS_SUCCESS:
      return {
        ...state,
        sub_teams: payload || [],
      };

    case ISignupStateTypes.FETCH_SINGUP_DESIGNATIONS_SUCCESS:
      return {
        ...state,
        designations: payload || [],
      };
    // fetching lists

    // FR Verification
    case ISignupStateTypes.FR_VERIFY_REQUEST:
      return {
        ...state,
        is_in_api_call: true,
        fRErrorMsg: "",
      };

    case ISignupStateTypes.FR_VERIFY_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        isFRVerificationDone: true,
        fRErrorMsg: "",
      };

    case ISignupStateTypes.FR_VERIFY_FAILURE:
      return {
        ...state,
        is_in_api_call: false,
        isFRVerificationDone: false,
        fRErrorMsg: payload?.error,
      };
    case ISignupStateTypes.FETCH_CHAT_HISTORY_REQUEST:
      return {
        ...state,
        chat_history: { isLoading: true },
      };

    case ISignupStateTypes.FETCH_CHAT_HISTORY_SUCCESS:
      return {
        ...state,
        chat_history: { ...payload, isLoading: false },
      };
    case ISignupStateTypes.FETCH_THREADHISTORY_REQUEST:
      return {
        ...state,
        chat_history: { isLoading: true },
      };

    case ISignupStateTypes.FETCH_THREADHISTORY_SUCCESS:
      return {
        ...state,
        chat_history: { ...payload, isLoading: false },
      };
    case ISignupStateTypes.UPDATE_CHAT_LIST:
      return {
        ...state,
        chat_list: [...state.chat_list, payload],
      };
    case ISignupStateTypes.EMPTY_CHAT_LIST:
      return {
        ...state,
        chat_history: {},
        chat_list: [],
      };

    case ISignupStateTypes.FETCH_SIGNUP_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        terms_and_condtions: payload,
      };

    case ISignupStateTypes.ACCEPT_SIGNUP_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        is_terms_and_conditions_done: true,
      };

    case ISignupStateTypes.ACCEPT_SIGNUP_TERMS_AND_CONDITIONS_FAILURE:
      return {
        ...state,
        is_in_api_call: false,
        is_terms_and_conditions_done: false,
      };

    // UPLOAD DOCUMENTS
    case ISignupStateTypes.SIGNUP_UPLOAD_DOCUMENTS_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        is_documents_uploaded: true,
      };

    case ISignupStateTypes.SIGNUP_UPLOAD_DOCUMENTS_FAILURE:
      return {
        ...state,
        is_in_api_call: false,
        is_documents_uploaded: false,
      };

    // Initialsing the signup
    case ISignupStateTypes.SIGNUP_INITIALISING:
      return {
        ...initialState,
      };

    case ISignupStateTypes.SIGNUP_FETCH_ALL_EDUCATIONS_SUCCESS:
      return {
        ...state,
        educations: payload,
      };

    case ISignupStateTypes.FETCH_ALL_LANGUAGES_SUCCESS:
      return {
        ...state,
        languages: payload,
      };

    case ISignupStateTypes.SIGNUP_FETCH_ALL_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: payload,
      };

    case ISignupStateTypes.SUBMIT_LOCATION_DETAILS_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        error: "",
      };

    case ISignupStateTypes.SUBMIT_EDUCATION_DETAILS_FAILURE:
      // SUBMIT_EDUCATION_DETAILS_FAILURE
      return {
        ...state,
        is_in_api_call: false,
        error: payload?.error || "",
      };

    case ISignupStateTypes.SUBMIT_EDUCATION_DETAILS_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        error: "",
      };

    case ISignupStateTypes.SUBMIT_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        error: "",
        bankDetailsError: "",
      };

    case ISignupStateTypes.FETCH_SIGNUP_FLOW_STAUTS_SUCCESS:
      return {
        ...state,
        is_in_api_call: false,
        error: "",
        ...payload,
      };

    default:
      return state;
  }
};

export default reducer;
